const state = {
  agent: null // debt report
}

const mutations = {
  setAgent: (state, agent) => {
    state.agent = agent
  }
}

const getters = {
  getAgent: state => state.agent
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
